import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

const CHAPTERS = [
    {
        number: "01",
        title: "Hands-on care over machine timers",
        content:
            "We do not hook you to passive machines and walk away. Every session is focused, manual physiotherapy delivered one-on-one by registered clinicians.",
        img: "https://images.unsplash.com/photo-1579488081688-3dbbbae7893e?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
        alt: "Warm, minimal clinic interior",
        caption: "Fig. 03 — The clinic, Elm Street",
    },
    {
        number: "02",
        title: "Back to work, sport & ordinary days",
        content:
            "Whether you are chasing a marathon, sitting without back strain, or lifting your child comfortably — treatment plans are built for real-world movement, not clinic scores.",
        img: "https://images.pexels.com/photos/20860598/pexels-photo-20860598.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        alt: "Therapist performing spine and back manual release",
        caption: "Fig. 04 — Spine & joint manual release",
    },
    {
        number: "03",
        title: "Fast access, no gates",
        content:
            "No doctor's referral is required. New patients are usually seen within 7 days — because an acute problem treated early rarely becomes a chronic one.",
        img: null,
    },
];

export const Manifesto = () => (
    <section id="manifesto" data-testid="manifesto-section" className="border-b border-line">
        <div className="mx-auto max-w-7xl px-5 py-24 sm:px-8 sm:py-32">
            <motion.p
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true, margin: "-100px" }}
                className="mb-16 font-mono text-[11px] uppercase tracking-[0.3em] text-mutedink"
                data-testid="manifesto-label"
            >
                The manifesto — how we practise
            </motion.p>
            <div className="flex flex-col gap-20 sm:gap-28">
                {CHAPTERS.map((c, i) => (
                    <motion.article
                        key={c.number}
                        data-testid={`manifesto-chapter-${c.number}`}
                        initial={{ opacity: 0, y: 48 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-100px" }}
                        transition={{ duration: 0.9, ease: EASE }}
                        className={`grid grid-cols-12 items-start gap-6 border-t border-line pt-10 ${
                            i % 2 === 1 ? "" : ""
                        }`}
                    >
                        <span className="col-span-2 font-mono text-sm text-ochre sm:col-span-1">
                            {c.number}
                        </span>
                        <div className={`col-span-10 ${c.img ? "sm:col-span-6" : "sm:col-span-8"}`}>
                            <h2 className="font-syne text-3xl font-semibold leading-none tracking-tight sm:text-4xl lg:text-5xl">
                                {c.title}
                            </h2>
                            <p className="mt-6 max-w-xl text-base leading-relaxed text-mutedink">
                                {c.content}
                            </p>
                        </div>
                        {c.img && (
                            <figure className="col-span-10 col-start-3 mt-4 sm:col-span-4 sm:col-start-9 sm:mt-0">
                                <div className="border border-line bg-white p-2 transition-transform duration-500 hover:-translate-y-1">
                                    <img
                                        src={c.img}
                                        alt={c.alt}
                                        className="aspect-[4/3] w-full object-cover grayscale-[35%]"
                                        loading="lazy"
                                    />
                                </div>
                                <figcaption className="mt-3 font-mono text-[10px] uppercase tracking-[0.2em] text-mutedink">
                                    {c.caption}
                                </figcaption>
                            </figure>
                        )}
                    </motion.article>
                ))}
            </div>
        </div>
    </section>
);
